import type { SVGProps } from 'react';

const SvgAcademy = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M28.27 12.3 16.21 7.19a.73.73 0 0 0-.58 0L3.56 12.3c-.28.12-.46.4-.46.71s.2.58.49.69l4.61 1.71v6.42c0 .37.27.69.64.74 2.33.34 4.52 1.14 6.52 2.4l.28.17c.12.08.26.12.4.12s.27-.04.39-.11l.5-.31c1.73-1.06 3.61-1.8 5.6-2.18l.49-.1a.76.76 0 0 0 .61-.74V15.4l2.13-.79v10.58h1.5V14.06l.97-.36c.29-.11.48-.38.49-.69s-.17-.59-.46-.71ZM15.92 8.7l10.03 4.25-10.03 3.73-10.03-3.73L15.92 8.7Zm6.22 12.51a18.01 18.01 0 0 0-5.99 2.35l-.1.06a17.953 17.953 0 0 0-6.34-2.43v-5.22l5.95 2.22c.08.03.17.05.26.05s.18-.02.26-.05l5.95-2.22v5.24Z"
    />
    <path
      fill={props.color}
      d="M29.02.36H2.98C1.46.36.23 1.59.23 3.11v25.78c0 1.52 1.23 2.75 2.75 2.75h26.04c1.52 0 2.75-1.23 2.75-2.75V3.11c0-1.52-1.23-2.75-2.75-2.75Zm1.25 28.53c0 .69-.56 1.25-1.25 1.25H2.98c-.69 0-1.25-.56-1.25-1.25V3.11c0-.69.56-1.25 1.25-1.25h26.04c.69 0 1.25.56 1.25 1.25v25.78Z"
    />
  </svg>
);

export default SvgAcademy;
